// Apothecary brand tokens — shared colour + type scales.
// Ported verbatim from the Stillhouse design system (window.APO.C / window.APO.F).

export const C = {
  // surfaces (dark)
  ink: "#0C1014",
  inkHi: "#0F1419",
  surface: "#141A21",
  surfaceHi: "#1A222B",
  line: "#22303D",
  lineHi: "#2D3D4D",
  // surfaces (light)
  bone: "#F3F5F1",
  boneHi: "#FBFCF9",
  boneLine: "#E3E5DF",
  // type
  fgDark: "#E8EDE8",
  fgMute: "#8E9BA5",
  fgFaint: "#5A6770",
  fgLight: "#15191E",
  fgLightMute: "#5C6770",
  // accents
  glow: "#C8FF6B", // primary accent — distillate
  glowDp: "#7CCC2E",
  glowSoft: "rgba(200,255,107,0.12)",
  amber: "#FFB347", // warning
  rose: "#FF6F8F", // danger
  lilac: "#B8A4FF", // info
} as const;

export const F = {
  display: '"Bricolage Grotesque", "Inter Tight", system-ui, sans-serif',
  ui: '"Geist", "Inter Tight", system-ui, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, monospace',
} as const;

export type ColorToken = keyof typeof C;
